import React, { Component } from 'react';
import PropTypes from 'prop-types';

class AnalyticsSummary extends Component {
  static displayName = 'AnalyticsSummary';

  static propTypes = {
    items: PropTypes.array.isRequired
  };

  render() {
    var { items } = this.props;
    return (
      <div className="summary">
        {items.map(item => (
          <div key={item.description} className="summary-item">
            <div className="item-amount">{item.amount}</div>
            <div className="item-description">{item.description}</div>
          </div>
        ))}
      </div>
    );
  }
}

export default AnalyticsSummary;
